import { createSelector } from 'reselect';

import { appState } from './utils';
import { isRunningContextCypress } from 'moet-test-utils/cypress/utils';

const isCypress = isRunningContextCypress(window);
const _recaptcha = createSelector(appState, ({ recaptcha = {} }) => recaptcha);

export const shouldExecute = createSelector(_recaptcha, ({ execute }) => execute);

export const recaptchaResponseToken = createSelector(_recaptcha, ({ token }) => token);

export const hasValidRecaptchaToken = createSelector(
  _recaptcha,
  ({ token, timestamp }) => !!token && !!timestamp,
);

export const recaptchaChallengeCompleted = createSelector(
  _recaptcha,
  hasValidRecaptchaToken,
  ({ skip, execute }, hasValidRecaptchaToken) =>
    !execute && (skip || isCypress || hasValidRecaptchaToken),
);
